/* eslint-disable no-undef, no-empty */

import getEnvironDomain from 'ati-utils/getEnvironDomain';

/**
 * https://github.com/getsentry/sentry-docs/blob/master/src/collections/_documentation/platforms/javascript/advance-settings.md
 */

class Logger {
  constructor() {
    this.enabled = process.env.TARGET !== 'development' && typeof Sentry !== 'undefined';

    const currentDomain = getEnvironDomain();
    const dsn = `https://b1988ad034674ad6b6e95cdb361cff42@s1.${currentDomain}/107`;

    if (this.enabled) {
      try {
        this.errno = new window.Errno({
          dsn,
          release: SENTRY_RELEASE,
          environment: process.env.TARGET,
          autoSessionTracking: true,
          ignoreErrors: ['yaCounter', 'window.cb', 'VK is not defined'],
          integrations: [
            new window.Sentry.Integrations.BrowserTracing(),
          ],
          tracesSampleRate: 0.3,
          beforeSend(event) {
            // Фильтрация нежелательных ошибок
            if (event.tags?.appName === 'header') {
              return null;
            }
            return event;
          },
        });
        window.__SENTRY__.errno = this.errno;
      } catch (error) {
        this.enabled = false;
      }
    }
  }

  log = (message) => {
    if (!this.enabled) return;

    try {
      this.errno.captureMessage(message);
    } catch (e) { }
  };

  error = (exception, options) => {
    if (!this.enabled) return;

    try {
      this.errno.captureException(exception, options);
    } catch (e) { }
  }
}

export default new Logger();
